module.exports = __webpack_public_path__ + "src/app/assets/images/codegarden.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/codegarden.png
// module id = 630
// module chunks = 0